import React from "react";
import { useFormikContext } from "formik";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import CheckboxField from "../../form/CheckboxField";
import useFilterFields from "../../../hooks/useFilterFields";
import useAuth from "../../../hooks/useAuth";

const styles = {
  headerCell: {
    fontWeight: "semibold",
    fontSize: 16,
  },
  cell: {
    fontSize: 16,
  },
  returnIcon: {
    mr: 1,
    transform: "rotate(180deg) scaleY(-1)",
  },
  checkboxContainer: {
    ml: 7,
  },
  checkbox: {
    p: 0,
  },
};

export default function AdvancedOptionsTable({ search = "", project }) {
  const { setFieldValue } = useFormikContext();
  const { user } = useAuth();
  const { settings } = user.company;
  const additionalBillingWizardSteps = settings?.additional_billing_wizard_steps === true;

  const list = [
    [
      "referenceAssets",
      "Reference SKU Library in Receiving Assistant",
      "importedAssets",
      project?.kitting,
    ],
    ...(additionalBillingWizardSteps
      ? []
      : [["receivingWizardBillingStep", "Additional Ancillary Charges Step", "", false]]),
  ];

  const filteredList = useFilterFields(list, search, 1);

  if (filteredList.length === 0) {
    return null;
  }

  return (
    <>
      <TableHead>
        <TableRow>
          <TableCell sx={styles.headerCell}>Advanced Options</TableCell>
          <TableCell sx={styles.cell} />
        </TableRow>
      </TableHead>
      <TableBody>
        {filteredList.map(([name, label, clearField, disabled]) => (
          <TableRow key={name}>
            <TableCell sx={styles.cell}>
              <Box display="flex" alignItems="center">
                <KeyboardReturnIcon htmlColor="#d5d5d5" sx={styles.returnIcon} />
                <Typography fontSize={16}>{label}</Typography>
              </Box>
            </TableCell>
            <TableCell sx={styles.cell}>
              <Box
                sx={styles.checkboxContainer}
                onClick={() => clearField && !disabled && setFieldValue(clearField, false)}
              >
                <CheckboxField name={name} label="" sx={styles.checkbox} disabled={disabled} />
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
}
